<div class="public-page">
    <div class="approval-detail">
        <div class="public-brand">
            <img src="assets/logos/logo.png" alt="" />
            Comunidad Avalanz
        </div>

        <div *ngIf="loading" class="flex justify-content-center align-items-center py-8">
            <p-progressSpinner strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
        </div>

        <!-- Enlace inválido o sin token -->
        <section *ngIf="!loading && !success" class="panel state-panel" data-tone="rejected">
            <p class="status-line"><span class="status-dot"></span>Enlace no válido</p>
            <h1 class="detail-title">No pudimos abrir la requisición</h1>
            <p>{{ error || 'El enlace no es válido o está incompleto.' }}</p>
            <p>Si necesitas revisarla, solicita un nuevo enlace o entra a Comunidad Avalanz.</p>
        </section>

        <ng-container *ngIf="!loading && success && requisition">
            <!-- Encabezado: estado como línea de color sobre el título -->
            <header class="detail-header" [attr.data-tone]="getStatusTone(requisition.currentStatus?.code)">
                <div class="min-w-0">
                    <p class="status-line">
                        <span class="status-dot"></span>{{ requisition.currentStatus?.name }}
                        <span *ngIf="hasAction('approve') && !linkExpired" class="status-note">· requiere tu aprobación</span>
                    </p>
                    <h1 class="detail-title">Requisición de personal</h1>
                    <p class="detail-subtitle">
                        <span *ngIf="requisition.code" class="code">{{ requisition.code }}</span>
                        <span *ngIf="requisition.createdOn">Creada el {{ requisition.createdOn | date : "d 'de' MMMM 'de' y" }}</span>
                    </p>
                </div>

                <div class="detail-actions">
                    <p-button
                        *ngIf="hasAction('reject')"
                        label="Rechazar"
                        icon="pi pi-times"
                        styleClass="p-button-outlined p-button-danger"
                        [disabled]="linkExpired"
                        (onClick)="rejectRequisition()"></p-button>
                    <p-button
                        *ngIf="hasAction('approve')"
                        label="Aprobar"
                        icon="pi pi-check"
                        [disabled]="linkExpired"
                        (onClick)="approveRequisition()"></p-button>
                    <p-button
                        *ngIf="hasAction('submit')"
                        label="Enviar"
                        icon="pi pi-send"
                        [disabled]="linkExpired"
                        (onClick)="submitRequisition()"></p-button>
                    <p-button
                        *ngIf="hasAction('resubmit')"
                        label="Volver a enviar"
                        icon="pi pi-refresh"
                        [disabled]="linkExpired"
                        (onClick)="submitRequisition()"></p-button>
                </div>
            </header>

            <app-link-expiration
                *ngIf="expirationDate"
                [expirationDate]="expirationDate"
                (expirationStatusChanged)="onExpirationStatusChanged($event)"></app-link-expiration>

            <div class="detail-layout">
                <main class="detail-main">
                    <!-- Solicitante y datos de la vacante -->
                    <section class="panel">
                        <div class="person-head">
                            <p-avatar
                                shape="circle"
                                size="large"
                                [image]="requisition.createdByUser?.photoProfileUrl || undefined"
                                [label]="requisition.createdByUser?.photoProfileUrl ? undefined : initials(fullName(requisition.createdByUser))"></p-avatar>
                            <div class="min-w-0">
                                <div class="person-head-name">{{ fullName(requisition.createdByUser) }}</div>
                                <div class="person-head-meta">
                                    <span class="company-dot" [style.background-color]="requisition.createdByUser?.company?.color || '#CCCCCC'"></span>
                                    {{ requisition.createdByUser?.company?.name }} · Solicitante
                                </div>
                            </div>
                        </div>

                        <dl class="facts">
                            <div class="fact-row">
                                <dt>Puesto</dt>
                                <dd>{{ requisition.jobPosition?.name || '—' }}</dd>
                            </div>
                            <div class="fact-row">
                                <dt>Tipo</dt>
                                <dd>{{ requisition.requisitionType?.name || '—' }}</dd>
                            </div>
                            <div class="fact-row" *ngIf="requisition.requisitionType?.code === 'REPLACEMENT'">
                                <dt>Empleado a sustituir</dt>
                                <dd>{{ requisition.employeeReplaceName || '—' }}</dd>
                            </div>
                            <div class="fact-row">
                                <dt>Ciudad</dt>
                                <dd>{{ requisition.city || '—' }}</dd>
                            </div>
                        </dl>
                    </section>

                    <!-- Puesto -->
                    <section class="panel" *ngIf="requisition.jobPosition?.positionObjective || requisition.jobPosition?.responsibilities">
                        <h2 class="panel-title">Detalle del puesto</h2>
                        <div class="text-block" *ngIf="requisition.jobPosition?.positionObjective">
                            <p class="text-block-label">Objetivo del puesto</p>
                            <p class="text-block-body">{{ requisition.jobPosition?.positionObjective }}</p>
                        </div>
                        <div class="text-block" *ngIf="requisition.jobPosition?.responsibilities">
                            <p class="text-block-label">Responsabilidades</p>
                            <p class="text-block-body">{{ requisition.jobPosition?.responsibilities }}</p>
                        </div>
                    </section>

                    <!-- Comentarios -->
                    <section class="panel">
                        <h2 class="panel-title">
                            Comentarios
                            <span class="count" *ngIf="requisition.requisitionComments?.length">{{ requisition.requisitionComments.length }}</span>
                        </h2>
                        <ul class="comments" *ngIf="requisition.requisitionComments?.length; else noComments">
                            <li *ngFor="let comment of requisition.requisitionComments">
                                <p-avatar
                                    shape="circle"
                                    [image]="comment.user?.photoProfileUrl || undefined"
                                    [label]="comment.user?.photoProfileUrl ? undefined : initials(fullName(comment.user))"></p-avatar>
                                <div class="comment-body">
                                    <div class="comment-head">
                                        <span class="comment-author">{{ fullName(comment.user) }}</span>
                                        <span class="comment-meta">{{ comment.commentType?.name }} · {{ comment.createdOn | date : "d MMM y, h:mm a" }}</span>
                                    </div>
                                    <p class="quote">{{ comment.comment }}</p>
                                </div>
                            </li>
                        </ul>
                        <ng-template #noComments>
                            <p class="empty-state">Aún no hay comentarios.</p>
                        </ng-template>
                    </section>
                </main>

                <aside class="detail-aside">
                    <!-- Cadena de aprobación -->
                    <section class="panel">
                        <h2 class="panel-title">Cadena de aprobación</h2>
                        <ul class="people">
                            <li *ngFor="let p of approvalChain">
                                <p-avatar
                                    shape="circle"
                                    [image]="p.person?.photoProfileUrl || undefined"
                                    [label]="p.person && !p.person.photoProfileUrl ? initials(fullName(p.person)) : undefined"
                                    [icon]="p.person ? undefined : 'pi pi-user'"></p-avatar>
                                <div class="min-w-0">
                                    <div class="person-name">{{ fullName(p.person) || 'Sin asignar' }}</div>
                                    <div class="person-role">{{ p.role }}</div>
                                </div>
                            </li>
                        </ul>
                    </section>

                    <!-- Historial -->
                    <section class="panel" *ngIf="requisition.requisitionStatusHistories?.length">
                        <h2 class="panel-title">Historial</h2>
                        <ol class="history">
                            <li
                                *ngFor="let entry of requisition.requisitionStatusHistories"
                                [attr.data-tone]="getStatusTone(entry.status?.code)">
                                <span class="history-marker"><i [ngClass]="getStatusIcon(entry.status?.code)"></i></span>
                                <div class="history-body">
                                    <div class="history-status">{{ entry.status?.name }}</div>
                                    <div class="history-meta">
                                        <ng-container *ngIf="entry.changedUser">{{ fullName(entry.changedUser) }} · </ng-container>
                                        {{ entry.createdOn | date : "d MMM y, h:mm a" }}
                                    </div>
                                </div>
                            </li>
                        </ol>
                    </section>
                </aside>
            </div>
        </ng-container>

        <footer class="public-footer">
            ¿Tienes dudas? Escríbenos a <a href="mailto:comunidad@avalanz.com">comunidad&#64;avalanz.com</a>.
        </footer>
    </div>
</div>

<!-- Submit dialog -->
<p-dialog
    [(visible)]="submitDialogVisible"
    header="Enviar requisición"
    [modal]="true"
    [style]="{ width: '500px' }"
    [breakpoints]="{ '575px': '95vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="p-fluid">
        <div class="field">
            <label for="submitComments" class="font-medium">Comentarios *</label>
            <textarea
                id="submitComments"
                rows="5"
                class="w-full"
                pInputTextarea
                [(ngModel)]="commentText"
                [ngClass]="{ 'ng-invalid ng-dirty': commentError }"
                placeholder="Añade tus comentarios sobre esta requisición"
            ></textarea>
            <small *ngIf="commentError" class="p-error">El comentario es obligatorio</small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" styleClass="p-button-text p-button-secondary" (onClick)="cancelDialog()"></p-button>
        <p-button icon="pi pi-send" label="Enviar" [loading]="processingAction" (onClick)="confirmSubmit()"></p-button>
    </ng-template>
</p-dialog>

<!-- Approve dialog -->
<p-dialog
    [(visible)]="approveDialogVisible"
    header="Aprobar requisición"
    [modal]="true"
    [style]="{ width: '500px' }"
    [breakpoints]="{ '575px': '95vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="p-fluid">
        <div class="field">
            <label for="approveComments" class="font-medium">Comentarios *</label>
            <textarea
                id="approveComments"
                rows="5"
                class="w-full"
                pInputTextarea
                [(ngModel)]="commentText"
                [ngClass]="{ 'ng-invalid ng-dirty': commentError }"
                placeholder="Añade tus comentarios de aprobación"
            ></textarea>
            <small *ngIf="commentError" class="p-error">El comentario es obligatorio</small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" styleClass="p-button-text p-button-secondary" (onClick)="cancelDialog()"></p-button>
        <p-button icon="pi pi-check" label="Aprobar" [loading]="processingAction" (onClick)="confirmApprove()"></p-button>
    </ng-template>
</p-dialog>

<!-- Reject dialog -->
<p-dialog
    [(visible)]="rejectDialogVisible"
    header="Rechazar requisición"
    [modal]="true"
    [style]="{ width: '500px' }"
    [breakpoints]="{ '575px': '95vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="p-fluid">
        <div class="field">
            <label for="rejectComments" class="font-medium">Motivo del rechazo *</label>
            <textarea
                id="rejectComments"
                rows="5"
                class="w-full"
                pInputTextarea
                [(ngModel)]="commentText"
                [ngClass]="{ 'ng-invalid ng-dirty': commentError }"
                placeholder="Indica detalladamente el motivo del rechazo"
            ></textarea>
            <small *ngIf="commentError" class="p-error">El motivo es obligatorio</small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" styleClass="p-button-text p-button-secondary" (onClick)="cancelDialog()"></p-button>
        <p-button icon="pi pi-times" label="Rechazar" styleClass="p-button-danger" [loading]="processingAction" (onClick)="confirmReject()"></p-button>
    </ng-template>
</p-dialog>

<p-toast key="tst" position="top-right"></p-toast>
